// App.js
import React, { useState } from 'react';
import { Box, CssBaseline, Toolbar } from '@mui/material';
import Header from '../compoonents/Header';
import Sidebar from '../compoonents/Sidebar';
import Notifications from '../compoonents/Notifications';
import Messages from '../compoonents/Messages';
import Shortcuts from '../compoonents/Shortcuts';

function HomePageTest() {
  const [menuClicked, setMenuClicked] = useState(false);

  const handleDrawerToggle = () => {
    setMenuClicked(!menuClicked);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Header onMenuClick={handleDrawerToggle} />
      <Sidebar menuClicked={menuClicked} />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <Notifications />
        <Messages />
        <Shortcuts />
      </Box>
    </Box>
  );
}

export default HomePageTest;